var React = require('react');

function PortraitBeauty (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 8c5.523 0 10 4 10 7s-4.477 7-10 7-10-4-10-7 4.477-7 10-7zm0 4a3 3 0 100 6 3 3 0 000-6zM4.246 4.395l1.147 1.638a1 1 0 01-.148 1.315l-.098.078a1 1 0 01-1.393-.246L2.607 5.542a1 1 0 011.639-1.147zm15.508 0a1 1 0 011.639 1.147L20.246 7.18a1 1 0 01-1.393.246l-.098-.078a1 1 0 01-.148-1.315zM12 2a1 1 0 011 1v2a1 1 0 01-.883.993L12 6a1 1 0 01-1-1V3a1 1 0 011-1z","fillRule":"evenodd"}));
}

PortraitBeauty.defaultProps = {"width":"24","height":"24"};

module.exports = PortraitBeauty;

PortraitBeauty.default = PortraitBeauty;
